// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"2447526a","28":"6c6cb90a","116":"a3b1c3f3","204":"02392180","235":"d40f0d94","458":"9721f103","544":"a669c5cb","564":"a0e94dde","575":"f22f1370","710":"29ef1f14","778":"8c78ae69","822":"3fc8f647","828":"a2b7998b","842":"d317177f"}[chunkId] + ".chunk.js";
};